import { render, staticRenderFns } from "./Supports.vue?vue&type=template&id=26c14b3d"
import script from "./Supports.vue?vue&type=script&lang=js"
export * from "./Supports.vue?vue&type=script&lang=js"
import style0 from "./Supports.vue?vue&type=style&index=0&id=26c14b3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports